/** Copy and sample data for product demo illustrations — all illustrative, not real user data. */

export const DEMO_WAVE_BARS = [10, 18, 14, 26, 12, 22, 16, 24, 13, 28, 15, 20];

export const WHY_IT_MATTERS_CARDS = [
  {
    id: 'voice',
    title: 'Voice note',
    sample: '"She always hummed while she cooked…"',
    meta: '3:42 · Private · Transcript ready',
  },
  {
    id: 'document',
    title: 'Document',
    sample: 'Marriage certificate · 1962',
    meta: 'Linked to Eleanor Morrison',
  },
  {
    id: 'story',
    title: 'Written story',
    sample: 'Sunday dinners smelled like rain on the orchard path…',
    meta: 'Draft · Chapter 2',
  },
];

export const STORY_PROMPTS = [
  'What was your childhood home like?',
  'Who taught you something you never forgot?',
  'What family tradition should never disappear?',
];

export const SAMPLE_ARCHIVE = {
  name: 'The Morrison Family Archive',
  person: 'Eleanor Morrison',
  personMeta: '1928 – 2019 · Mother & storyteller',
  voiceLabel: 'Voice memory · Kitchen stories',
  documentLabel: 'Marriage certificate · 1962',
  connections: ['James Morrison · Partner', 'Sarah Morrison · Daughter'],
};

export const POSSESSION_SAMPLES = [
  { label: 'Birth certificate', meta: 'Official record · 1928' },
  { label: 'Marriage certificate', meta: 'County register · 1962' },
  { label: "Grandmother's recipe card", meta: 'Handwritten · Sunday roast' },
  { label: "Father's pocket watch", meta: 'Priceless possession · 1940s' },
];

export const FAMILY_CONNECTION_SAMPLES = [
  { label: 'Family tree', detail: 'Three generations linked' },
  { label: 'Birthday reminder', detail: 'Sarah · 14 March' },
  { label: 'Remembrance day', detail: 'Quiet annual prompt' },
  { label: 'Invite family', detail: 'View or edit access' },
];

export const PRIVACY_TRUST_ITEMS = [
  'Private by default',
  'You choose what to share',
  'Export anytime',
  'Memorials are optional',
  'DNA is optional and private',
];

export const HOMEPAGE_TEASER_IDS = ['why', 'archive', 'prompts', 'voice'];
